import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

/**
 * Represents an Image.
 * @param {string} className [optional=""] - css class
 * @param {string} src [optional=""] - Source to the file (needed if generatedImage is not present).
 * @param {string} alt [optional=""] - Alternative text.
 * @param {object} imageSharp [optional={}] - Image generated by imageSharp (needed if src is not present)
 */
const Image = ({ src, alt, imageSharp, className, preserveAspectRatio }) => {
  const imageData = getImage(imageSharp);
  if (imageData) {
    return <GatsbyImage className={className} image={imageData} alt={alt} />;
  }
  if (src) {
    return <img className={className} src={src} alt={alt} />;
  }
  return null;
};

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  imageSharp: PropTypes.object,
  className: PropTypes.string,
};

Image.defaultProps = {
  src: '',
  alt: '',
  className: '',
};

export default Image;
